import { useState, useContext } from 'react';
import { useTranslation } from "react-i18next";

import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from "react-hook-form";
import SystemContext from "../../../../context/systemContext/context";

//components
import { toast } from "react-toastify";
import { Button, Container, Row, Col, Form, Stack, Spinner } from 'react-bootstrap';
import { Illustration } from '../styled';
import Error from "../../../components/Error";

//images
import logo from "../../../../assets/img/logo.svg";
import logoWhite from "../../../../assets/img/logo-white.svg";
import loginIllustration from "../../../../assets/img/login-illustration.png";

//services
import { recoveryPassword } from "../../../services/login/login.service";
import { FaChevronLeft } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';

const validationSchema = Yup.object({
  email: Yup.string().email('E-mail inválido').required("Este campo é obrigatório"),
}).required();

export const RecoveryPassword = (): JSX.Element => {
  const history = useHistory();
  const { systemConfig } = useContext(SystemContext)
  const { t: translation } = useTranslation();
  const { register, handleSubmit, formState: { errors } } = useForm({ resolver: yupResolver(validationSchema) });

  const [loading, setLoading] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  const onSubmit = (formParams: any) => {
    setLoading(true);
    recoveryPassword(formParams.email).then(() => {
      setShowSuccessMessage(true);
    }).catch(() => {
      toast.error('Ocorreu um erro ao enviar o email de recuperação de senha');
      setLoading(false);
    });
  }

  const handleRedirectToLogin = () => {
    window.location.href = '/login'
  }

  return (
    <Container fluid>
      <Row className="row-card-login">
        <div className="back-auth-div">
          <span className="back-auth-button" onClick={() => history.push("/login")}>
            <FaChevronLeft size="16" style={{ marginRight: "8px", marginBottom: "2px" }} /> <span className="font-16"><b>Voltar</b></span>
          </span>
        </div>
        <Col xs={'auto'} lg={6} xl={7} xxl={8} className="p-0 vh-100 d-flex justify-content-center align-items-center">
          <Row className="row-illustration-login">
            <Col xs={12} className="vh-50 illustration">
              <Illustration image={loginIllustration}/>
            </Col>
            <Col xs={12} className="text-center text-welcome">
              <h3 className="text-white"><b>{translation('login.welcome')}</b></h3>
              <h5 className="text-white">{translation('login.description')}</h5>
            </Col>
          </Row>
        </Col>
        <Col className="d-flex justify-content-center card-login">
          <div className="wrapper-login">
            {
              showSuccessMessage ? (
                <>
                  <Col className="text-center mb-2rem">
                    { systemConfig.theme === "light" ? (<img src={logo} alt="Logo" className="mb-2rem" />) : (<img src={logoWhite} alt="Logo" height={65} className="mb-2rem" />) }
                    <p className="text-black text-center mb-0" style={{ fontSize: '18px' }}><b>{translation('login.recoveryPasswordSuccess')}</b></p>
                    <p className="text-darker-grey text-center mt-3 mb-0" style={{ fontSize: '16px' }}>{translation('login.recoveryPasswordSuccessDescription')}</p>
                  </Col>

                  <Stack gap={4} className="col-12 mx-auto text-center">
                    <Button variant="primary" type="submit" className="btn-rounded" onClick={() => handleRedirectToLogin()}><b>{translation('login.login').toUpperCase()}</b></Button>
                  </Stack>
                </>
              ) : (
                <Form className="w-100 form-auth" onSubmit={handleSubmit(onSubmit)}>
                  <Col className="text-center mb-2rem">
                    { systemConfig.theme === "light" ? (<img src={logo} alt="Logo" />) : (<img src={logoWhite} alt="Logo" height={65} />) }
                  </Col>
                  <p className="text-black text-center mb-0" style={{ fontSize: '18px' }}><b>{translation('login.recoveryPassword')}</b></p>
                  <p className="text-darker-grey text-center mt-3 mb-3" style={{ fontSize: '16px' }}>{translation('login.recoveryPasswordDescripton')}</p>

                  <Form.Group className="mb-2rem">
                    <Form.Label className="text-black font-14"><b>{translation('login.email')}</b></Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Digite seu e-mail"
                      aria-label={translation('login.email')}
                      {...register("email", { required: true })}
                    />
                    {errors.email ? (<div className="w-100"> <Error>{errors.email?.message}</Error> </div>) : ""}
                  </Form.Group>
                  
                  {
                    loading ? 
                    (
                      <div className="loading-container mt-5">
                        <Spinner animation="border" variant="primary" />
                      </div>
                    ) :
                    (
                      <Stack gap={4} className="col-12 mx-auto text-center">
                        <Button variant="primary" type="submit" className="btn-rounded"><b>{translation('login.recoveryPasswordButton').toUpperCase()}</b></Button>
                      </Stack>
                    )
                  }
                </Form>
              )
            }
          </div>
        </Col>
      </Row>
    </Container>
  )
}